import * as React from 'react';
import type { SVGProps } from 'react';
const SvgQuestionFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="question-full"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle
      cx={10}
      cy={10}
      r={8}
      fill="var(--color-content-status-neutral-secondary)"
    />
    <path
      fill="var(--color-content-inverted-base-primary)"
      fillRule="evenodd"
      d="M10.456 6.902c-.929-.317-1.579.2-1.764.518a.8.8 0 0 1-1.383-.805c.493-.845 1.878-1.836 3.663-1.228a2.7 2.7 0 0 1 1.677 1.667c.246.696.219 1.55-.286 2.2-.483.623-1.006 1.023-1.478 1.247l-.343-.722.343.722a.4.4 0 0 0-.085.058v.242a.8.8 0 1 1-1.6 0v-.307c0-.758.586-1.242.998-1.438.223-.106.556-.338.902-.783.09-.116.153-.367.04-.687a1.1 1.1 0 0 0-.684-.684"
      clipRule="evenodd"
    />
    <path
      fill="var(--color-content-inverted-base-primary)"
      d="M11 13.8a1 1 0 1 1-1.999 0 1 1 0 0 1 1.999 0"
    />
  </svg>
);
export default SvgQuestionFull;
